import { HOST } from "common-import/constants";
import { observable, autorun } from "mobx";
import { Request, MobXHelper } from "common-import/helpers";
const { makePersit } = MobXHelper;
import api from "./Membership.API";

const PERSIST_STORE_ITEM = {
  USER_DATA: "USER_STORE_USER_DATA"
};

class MembershipStore {

  @observable listParticipant = [];

  getList = async () => {
    const res = await api.list();
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  create = async (data) => {
    const res = await api.create(data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  delete = async (id) => {
    const res = await api.delete(id);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  }
}

const membershipStore = new MembershipStore();

export default membershipStore;



// WEBPACK FOOTER //
// ./src/services/membership/Membership.Store.js